import React from 'react';
import BlankScreenSideTextComponent from './BlankScreenSideTextComponent';
import VideoEmbedder from './VideoEmbedder';
var SubAgentBlankScreen = function (_a) {
    var handleButtonClick = _a.handleButtonClick, videoUrl = _a.videoUrl;
    return (React.createElement("div", { className: "lfc-p-4 lfc-grid lfc-grid-cols-2 lfc-gap-x-4" },
        React.createElement(BlankScreenSideTextComponent, { handleButtonClick: handleButtonClick }),
        React.createElement("div", { className: "lfc-p-2 lfc-bg-gbTokens-grey-200 lfc-rounded-lg lfc-border lfc-border-gbTokens-grey-A500" },
            React.createElement(VideoEmbedder, { url: videoUrl }))));
};
export default SubAgentBlankScreen;
//# sourceMappingURL=BlankScreen.js.map